module.exports = __webpack_public_path__ + "static/media/webcam-slash.3862ec0e.svg";